<template lang="html" >
  <div style="background-color: white;" class="scrolling-wrapper">
    <div class="mb-5">
     <Navbar/>
    </div>
    <v-container style="height: calc(100vh - 64px);" >
      <v-layout style="justify-content: center !important;">
        <v-flex md6 style="padding-top: 60px;" class="hidden-md-and-down">
          <v-layout align-center column justify-center  wrap >
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                <img src="/static/img/icons/logoonechat_full.png" style="height: 70px; justify-content: right;">
            </v-flex>
            <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;color: black;display: flex;justify-content: center;">
                <h1>{{$t('Register.title1')}}</h1>
            </v-flex>
                <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
                  <v-container class="setBolderRegister">
                    <v-layout row wrap>
                      <v-flex xs12 class="centerDiv">
                        <span style="font-size: 25px" class="CSChatThai">{{$t('Register.title2')}}</span>
                      </v-flex>
                      <v-flex xs12 class="centerDiv">
                        <span style="font-size: 25px" class="CSChatThai">{{$t('Register.title4')}}</span>
                      </v-flex>
                      <v-flex xs5 class="centerDiv pl-5"  style="color: #2562af;">
                        <span style="font-size: 50px" class="CSChatThai">{{$t('Register.span1')}}</span>
                      </v-flex>
                      <v-flex xs7>
                        <v-flex xs12 class="CSChatThai">
                          <v-icon class="pt-0 pr-3" large style="color: #2562af;">mail</v-icon>
                          <span style="font-size: 25px">{{$t('Register.span2')}}</span>
                        </v-flex>
                        <v-flex xs12 class="CSChatThai">
                          <v-icon class="pt-0 pr-3 " large  style="color: #2562af;">cloud</v-icon>
                          <span style="font-size: 25px">{{$t('Register.span3')}}</span>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
              </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md1></v-flex>
        <v-flex xs12 md5 style="padding-top:10px;">
          <div style="padding-top:10px;" class=""></div>
          <v-card class="setBolderRegister" style="background-color: white;">
            <v-card-text style="margin-top: 0; padding-left: 40px; padding-right: 40px;">
              <h2 style="color:black;" class="centerDiv CSChatThai">{{$t('Register.title3')}}</h2>
              <v-layout >
                <v-flex xs12>
                  <v-form v-model="valid" ref="form" class="CSChatThai labeltext">
                    <div style="margin-top: 30px;text-align: center;" v-if="type=='first'">
                     <v-text-field
                        :label="$t('Login.phone')"
                        v-model="phoneNumber"
                        mask="###-###-####"
                        :rules="phoneRules"
                        required
                        prepend-icon="phone"
                        single-line
                        style="width: 100% !important; color: #2562af !important;"
                        ></v-text-field>
                        <!-- <v-btn class="btnloginwebOneid_white" @click="getotp3()" :disabled="phoneNumber === ''" style="justify-self: center;margin-bottom: 30px;width: 20%;">ขอ OTP test</v-btn> -->
                        <v-btn class="btnloginwebOneid_white text-transform" @click="getotp()" :disabled="phoneNumber === ''" style="justify-self: center; margin-bottom: 30px;width: 20%;">{{$t('Login.Button.sendotp')}}</v-btn>
                      </div>

                      <div style="margin-top: 30px;text-align: center;" v-else-if="type=='otp'">
                         <p>{{$t('Login.phone')}}: {{phoneNumber}}</p>
                    <p  v-if="Refcode">Refcode: {{Refcode}}</p>
                    <div style="display: flex;">
                     <v-text-field
                        label="OTP"
                        v-model="otpCode"
                        required
                        single-line
                        maxlength="6"
                        style="width: 100% !important; color: #2562af !important;"
                        ></v-text-field>
                        <!-- <v-btn class="btnloginwebOneid_white" @click="otp()" style="justify-self: center;margin-bottom: 30px;width: 20%;">ขอ OTP</v-btn> -->

                        <v-btn depressed class="btnloginwebOneid_white text-transform" style="width: 25%; margin-top: 5px !important;" :disabled="counting" @click="getotp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                          <template slot-scope="props">{{ props.totalSeconds }} {{$t('Login.Button.time')}} </template>
                        </countdown>
                        <span v-if="!counting">{{$t('Login.Button.resend')}} </span>
                      </v-btn>
                    </div>
                  <v-checkbox
                    v-model="checkbox"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    dark>
                    <div slot="label" style="color: #2562af !important;" class="text-transform">
                      {{$t('Register.Button.accept')}}
                      <a style="color: gray !important; text-decoration: underline;" @click.stop="conditions = true">{{$t('Register.Button.policy')}}</a>
                    </div>
                  </v-checkbox>
                  <v-dialog v-model="conditions" width="70%">
                    <v-card>
                      <v-card-title class="title text-transform">{{$t('Register.Button.policy')}}</v-card-title>
                      <v-card-text v-html="content">
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        flat
                        color="blue"
                        @click="conditions = false"
                        class="text-transform"
                        >{{$t('AnswerQuestion.ok')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                <div style="justify-content: center; align-items: center; display: flex; margin-bottom: 5vh;">
                  <v-btn @click="backtoInputphone()" color="blue-grey" style="color: white !important;border-radius: 20px;" class="text-transform">{{$t('Register.Button.back')}}</v-btn>
                  <!-- <v-btn
                    @click="loginWithotp()"
                    :disabled="!(valid && otpCode.length==6)"
                    color="success"
                    :loading="isLoading"
                    style="border-radius: 20px;"
                    >
                    สมัครสมาชิก
                  </v-btn> -->
                  <v-btn
                    @click="loginWithotp()"
                    :disabled="!(valid && otpCode.length==6)"
                    color="success"
                    :loading="isLoading"
                    style="border-radius: 20px;"
                    class="text-transform"
                    >
                    {{$t('Register.Button.register')}}
                  </v-btn>
              </div>
                      </div>
              <div  style="justify-content: center;display: flex;" >
                <!-- <a > -->
                <span style="color: #004869; font-size: 12px;"> Powered By </span> &nbsp;&nbsp;&nbsp;
            <img src="/static/img/oneplatform/logo_one_platform.png" style="height: 30px;cursor: pointer;" @click="openlink('https://one.th/')">
          <!-- </a> -->
          </div>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
  <!-- <v-flex md3></v-flex> -->
<Dialogselectaccount :dialogSelectaccount="dialogSelectaccount" :list_accounts="list_accounts" :phoneNumber="phoneNumber"  @closeSelectaccount="closeSelectaccount"  />
<!-- <Editpictureprofile :dialogEditpictureprofile="dialogEditpictureprofile" @closeEditpictureprofile="closeEditpictureprofile"></Editpictureprofile> -->
</v-layout>
<!-- <NewFooter/> -->
</v-container>

</div>

</template>

<script>
import Vue from 'vue'
import Navbar from '@/components/homepage/Navbar'
// import NewFooter from '@/components/home/NewFooter'
// import { sync } from 'vuex-pathify'

import {
  Encode
} from '@/services'
import {
  sync
} from 'vuex-pathify'
import Dialogselectaccount from '@/components/chat/dialog/SelectAccount'
import VueCountdown from '@chenfengyuan/vue-countdown'
Vue.component(VueCountdown.name, VueCountdown)
export default {
  components: {
    Dialogselectaccount,
    Navbar,
    ...sync('*')
    // NewFooter
  },
  data() {
    return {
      type: 'first',
      phoneNumber: '',
      content: '',
      date: null,
      dateShow: null,
      dateThai: null,
      conditions: false,
      valid: false,
      name: '',
      isLoading: false,
      phoneRules: [
        v => (!!v && v.length === 10) || this.$t('Homepage.Dialog.inputphoneErrorDigit'),
        v => !!v || this.$t('Homepage.Dialog.inputphoneErrorNumber'),
        v => /^0[0-9]{9}/.test(v) || this.$t('Homepage.Dialog.inputphoneErrorFormat')
      ],
      checkbox: false,
      webdev: process.env.WEBchatdev,
      counting: false,
      otpCode: '',
      mobile_ref_id: '',
      Refcode: '',
      type_otp: '',
      dialogSelectaccount: false,
      list_accounts: []
    }
  },
  created () {
    // this.$i18n.locale = 'th'
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.content = this.$t('Register.content')
  },
  methods: {
    loginWithotp2() {
      this.isLoading = true
      this.dialogSelectaccount = true
    },
    loginWithotp() {
      this.isLoading = true
      if (localStorage.type_register === 'true') {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id,
          consent_status: "Y"
        }
      } else {
        var source = {
          type_otp: this.type_otp,
          phone: this.phoneNumber,
          otp: this.otpCode,
          mobile_ref_id: this.mobile_ref_id
        }
      }
      // console.log(source)
      this.axios.post(process.env.APImanage + '/v2/login_and_regis', source).then((response) => {
        this.status = response.data['status']
        if (this.status === 'success') {
          // console.log(response)
          if (response.data.list_accounts !== undefined) {
            this.list_accounts = response.data.list_accounts
            // console.log(this.list_accounts)
            this.dialogSelectaccount = true
          } else {
            var profile = response.data['account']['profile']
            this.myprofilepicture = profile['profilepicture']
            this.myname = profile['name']
            this.$cookie.set('language', 'th')
            localStorage.setItem('Authenrization', Encode.encode({
              'tokenuser': profile['tokenuser'],
              'status_login': 'T',
              'type_user': profile['type']
            }))
            localStorage.setItem('profilepicture', profile['profilepicture'])
            localStorage.setItem('name', profile['name'])
            localStorage.setItem('phone', profile['phone'])
            localStorage.setItem('email', profile['email'])
            localStorage.setItem('status', profile['status'])
            localStorage.setItem('type_user', profile['type'])
            localStorage.setItem('wallpaperInfo', JSON.stringify({
              'info': [{
                'room': '',
                'background': ''
              }]
            }))
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false')
            } else {
              localStorage.setItem('status_username', 'true')
            }
            this.isLoading = false
            if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
              this.$router.push('/chat')
            } else {
              this.$router.push(localStorage.getItem('pathRoom'))
            }
          }
        } else if (response.data['message'] === 'The resource owner or authorization server denied the request.') {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal(
            '',
            this.$t('Alert.Login.otpInvalid'),
            'error'
          )
        } else {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal(
            '',
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.isLoading = false
        this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
      })
    },
    getotp3() {
      // this.type = "otp"
      this.dialogSelectaccount = true
    },
    getotp() {
      this.axios.post(process.env.APImanage + '/v2/otp_login_and_regis', {
        phone: this.phoneNumber,
        type: 'register'
      }).then((response) => {
        // console.log(response)
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'register') {
            localStorage.type_register = true
            // console.log('type otp = register')
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = "otp"
          } else if (response.data.type_otp == 'login') {
            this.$swal(
              '',
              this.$t('Alert.Login.phoneVerify'),
              'error'
            )
            // this.Refcode = response.data.refcode
            // this.mobile_ref_id = response.data.mobile_ref_id
            // this.type_otp = response.data.type_otp
            // this.counting = true
            // this.type="otp"
            // console.log('type otp = login')
          } else if (response.data.type_otp == 'select accounts') {
            // console.log('type otp = select account')
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = "otp"
            // this.dialogSelectaccount = true
          } else {
            this.phone = ''
            this.$swal(
              '',
              this.$t('Alert.Login.phoneVerify'),
              'error'
            )
          }

        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.isLoading = false
        this.type = 'first'
        this.failmessage = this.$t('Alert.Fail.default.somethingWrong')
      })
    },
    handleCountdownEnd() {
      this.OTP = ''
      this.counting = false
    },
    openlink(path) {
      window.open(path, '_blank')
    },
    toNewTab() {
      window.open(this.webdev, '_blank').focus()
    },
    linkAPI() {
      window.open('/docs', '_blank').focus()
    },
    toPage(page) {
      this.$router.push(page)
    },
    linkregister() {
      window.open('/register').focus()
    },
    linkdownload() {
      window.open('/download').focus()
    },
    isMobile() {
      if ($('#mobile').is(':hidden')) {
        return false
      } else {
        return true
      }
    },
    backtoInputphone() {
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Login.previouspage'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // this.valid = false
          this.type = "first"
          this.phoneNumber = ''
          this.Refcode = ''
          this.mobile_ref_id = ''
          this.type_otp = ''
          this.counting = false
          this.checkbox = false
        }
      })
    },
    closeSelectaccount(value) {
      this.dialogSelectaccount = value
    }
  },
  watch: {
    '$i18n.locale'() {
      // this.$i18n.locale = 'th'
      this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
      this.content = this.$t('Register.content')
    },
    date() {
      if (this.date !== null) {
        var year = (parseInt(this.date.split('-')[0]) + 543).toString()
        this.dateShow = this.date.split('-')[2] + '-' + this.date.split('-')[1] + '-' + year
        this.dateThai = (year - 543) + '-' + this.date.split('-')[1] + '-' + this.date.split('-')[2]
      }
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    dialogSelectaccount() {
      // console.log(this.dialogSelectaccount)
      if (this.dialogSelectaccount == false) {
        // console.log('test เข้า false')
        this.type = "otp"
        this.isLoading = false
      }
    }
  }
  // computed: {
  //   valid () {
  //     return (
  //       this.phoneNumber &&
  //       this.username &&
  //       this.password &&
  //       this.checkbox
  //     )
  //   }
  // },
}
</script>

<style type="text/css" scoped>
.text-transform {
  text-transform: none !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}

.setBolderRegister {
  border-style: solid solid solid solid !important;
  border-width: 1px !important;
  border-radius: 5px !important;
  border-color: rgb(143, 143, 143) !important;
}

p {
  margin-bottom: 0px;
}

a:link {
  text-decoration: none;
  color: white !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #2562af !important;
  text-decoration: none;
}

a:active {
  color: white !important;
  text-decoration: none;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #00000000 !important;
  color: white;
  text-align: center;
}

.footermo {
  /*position: fixed;*/
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #00000000 !important;
  color: white;
  text-align: center;
}

.centerDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.labeltext {
  color: black !important;
}

.application .input-group.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active),
.input-group.input-group--dirty .input-group__selections__comma:not(.input-group__selections__comma--active) {
  color: black !important;
}

.application .input-group input,
.application .input-group textarea,
.input-group input,
.input-group textarea {
  color: black !important;
}

/*input[type=textregis] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    background-image: url('../assets/image/group.png');
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 50px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
    color: black !important;
}*/

>>>.application .input-group input,
.application .input-group textarea,
.input-group input,
.input-group textarea {
  color: black !important;
}

>>>.input-group label {
  color: #757575 !important;
}

>>>.input-group i {
  color: #2562af !important;
}

>>>i .input-group__prepend-icon {
  color: #2562af !important;
}

>>>.input-group.input-group--error .input-group__messages {
  color: red !important;
}

>>>.input-group__input i {
  color: #2562af !important;
}

>>>.input-group__input input {
  color: #2562af !important;
}

>>>.input-group--text-field input {
  color: black;
}

>>>.input-group__input label {
  color: #2562af !important;
}

>>>.application .input-group:not(.input-group--error) label,
.input-group:not(.input-group--error) label {
  color: #2562af !important;
}

>>>.theme--light.v-icon {
  color: rgb(37, 98, 175) !important;
}

>>>.accent--text {
  color: #2562af !important;
  caret-color: #2562af !important;
}

>>>.theme--dark.v-icon {
  color: #2562af !important;
}

>>>.v-messages__message {
  line-height: normal !important;
}

.btnloginwebOneid_white {
  color: #2562af !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid #2562af;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/RegisterPhone.vue